import BlogCategory, {
  IBlogCategory,
} from '@wearesection/bandai-react-components/organisms/BlogCategory';
import Box from '@mui/material/Box';
import * as Types from 'graphql/types';
import React, {useMemo, useState} from 'react';
import {PLACEHOLDER_IMG} from '~/constants';
import {GetRouter, handleTranslateBlogTag} from '~/utils';
import RenderNextImage from '../../atoms/render-next-image';
import {handleReturnDateForLocal} from '../scrolling-thumbnail-card/scrolling-thumbnail-card';
import {usePageSetting} from '~/providers/page-context.provider';

const adapter = (data: any) => {
  const handleGetPillProps = () => {
    const dataPill = [
      {
        label: '뉴스',
        value: 'News',
        active: false,
        numberFilter: 0,
        iconMobile: false,
      },
      {
        label: '게임',
        value: 'Games',
        active: false,
        numberFilter: 0,
        iconMobile: false,
      },
      {
        label: '이벤트',
        value: 'Events',
        active: false,
        numberFilter: 0,
        iconMobile: false,
      },
    ];

    return dataPill;
  };

  const {pathname, locale} = GetRouter();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};

  return {
    title: data?.title ?? 'Blog',
    queryTag: data?.queryTag,
    pillProps: handleGetPillProps(),
    dataBlogCard: data?.listItemCollection?.items?.map((item: Types.Blog) => ({
      title: item?.title ?? '',
      hrefTag: `/${locale}${pathname}`,
      description: item?.shortDescription ?? '',
      linkHref: `/${locale}${pathname}/${item?.slug}` ?? '',
      mainImageNext: (
        <RenderNextImage
          src={(item?.gameTitle?.mainThumbnailImg as any)?.media?.url ?? PLACEHOLDER_IMG}
          width={601}
          height={306}
          alt={data?.title || ''}
        />
      ),
      date:
        handleReturnDateForLocal(locale || 'en-sg', `${item?.publishDate}`.substring(0, 10)) ?? '',
      tags: [
        {
          title: handleTranslateBlogTag(item?.primaryTag as string, dataTranslation),
          color: data.listTagsColor.find(
            (e: any) =>
              e.name ===
              handleTranslateBlogTag(
                item?.primaryTag?.toLocaleLowerCase() as string,
                dataTranslation
              )
          )?.backgroundColor,
        },
      ],
    })),
  };
};

const BlogCategoryComponent: React.FC<IBlogCategory> = props => {
  const blogCategoryProps = useMemo(() => adapter(props), [props]);
  const [showSearch, setShowSearch] = useState<string[]>([]);

  const handleGetPill = (e: string[]) => {
    setShowSearch(e);
    (props as any).handleConfirmIsFilter(e);
  };

  return (
    <Box
      sx={{
        paddingTop: {
          xs: '72px',
          lg: '80px',
        },
        paddingBottom: {
          xs: showSearch?.length ? '0px' : '72px',
          lg: showSearch?.length ? '0px' : '140px',
        },
      }}
    >
      <BlogCategory {...blogCategoryProps} pillSelected={handleGetPill} />
    </Box>
  );
};

export default BlogCategoryComponent;
